// ============================================================================
// @gs/feedback/client — bloc de citation quote-reply (CHORE-FBK-COMPOSER-V2)
// ============================================================================
// Norme Slack/WhatsApp : citation PLATE au-dessus du corps (pas de threading
// imbrique). Tokens DS : carte surface2 (slate-50 / slate-800-40) + LISERE
// GAUCHE NEUTRE (meme grammaire « le bord gauche dit l'etat » que les bannieres
// d'action — ici neutre : c'est une reference, pas un etat). Cliquable = scroll
// au message cite (callback onJump — le flash defensif vit chez l'appelant).
// Libelles par props (le composant est rendu sous le i18n de l'appelant).

export interface MessageQuoteProps {
  authorName: string;
  /** Extrait resolu SERVEUR (borne/assaini) — null = message cite supprime. */
  snippet: string | null;
  /** Libelle affiche quand le message cite est supprime (i18n appelant). */
  deletedLabel: string;
  /** a11y du bloc cliquable (ex. « Aller au message cite »). */
  jumpLabel: string;
  onJump: () => void;
}

export function MessageQuote({ authorName, snippet, deletedLabel, jumpLabel, onJump }: MessageQuoteProps) {
  return (
    <button
      type="button"
      onClick={onJump}
      aria-label={jumpLabel}
      title={jumpLabel}
      className={[
        'touch-manipulation mb-1.5 block w-full rounded-md border-l-2 border-slate-300 bg-slate-50',
        'px-2.5 py-1.5 text-left transition-colors hover:bg-slate-100',
        'dark:border-slate-600 dark:bg-slate-800/40 dark:hover:bg-slate-700/50',
      ].join(' ')}
    >
      <span className="block text-meta font-semibold text-slate-500 dark:text-slate-400">{authorName}</span>
      <span className={`block truncate text-meta ${snippet === null ? 'italic text-slate-400' : 'text-slate-600 dark:text-slate-300'}`}>
        {snippet ?? deletedLabel}
      </span>
    </button>
  );
}
